import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { TASK_SUB_CATEGORY_API } from "../apiRoutes";

interface UseGetSubCategoriesByCategoryIdProps {
  categoryId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getSubCategoriesByCategoryId = async (categoryId: string) => {
  return await axiosAuth.get(`${TASK_SUB_CATEGORY_API}/category/${categoryId}`);
};

const useGetSubCategoriesByCategoryId = ({categoryId, queryParams}: UseGetSubCategoriesByCategoryIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["sub-categories", categoryId],
    queryFn: () => getSubCategoriesByCategoryId(categoryId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!categoryId,
    ...queryParams,
  });
};

export default useGetSubCategoriesByCategoryId;
